import { render, staticRenderFns } from "./ShippingMethodForm.vue?vue&type=template&id=28d074cc&"
import script from "./ShippingMethodForm.vue?vue&type=script&lang=js&"
export * from "./ShippingMethodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports